import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal, SectionLabel } from "../components/Reveal";
import api from "../lib/api";

export default function Blog() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/blog").then((r) => setPosts(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <div className="pt-32 pb-24">
      <section className="max-w-7xl mx-auto px-6">
        <Reveal><SectionLabel>Journal</SectionLabel></Reveal>
        <Reveal delay={0.1}>
          <h1 className="font-serif-display text-5xl md:text-6xl mt-6 max-w-3xl leading-tight">
            Ideas, insights & inspiration.
          </h1>
        </Reveal>
      </section>

      <section className="max-w-7xl mx-auto px-6 mt-16">
        {loading ? (
          <p className="text-muted-foreground">Loading posts…</p>
        ) : posts.length === 0 ? (
          <p className="text-muted-foreground">No posts yet. Check back soon.</p>
        ) : (
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-10">
            {posts.map((p, i) => (
              <Reveal key={p.id} delay={i * 0.06}>
                <Link data-testid={`blog-card-${i}`} to={`/blog/${p.slug}`} className="group block">
                  <div className="rounded-2xl overflow-hidden aspect-[4/3] mb-5">
                    <img src={p.cover_image} alt={p.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
                  </div>
                  <p className="label-caps text-accent">{new Date(p.created_at).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" })}</p>
                  <h3 className="font-serif-display text-2xl mt-2 group-hover:text-accent transition-colors flex items-start gap-1">
                    {p.title} <ArrowUpRight size={18} className="mt-1.5 opacity-0 group-hover:opacity-100 transition-opacity" />
                  </h3>
                  <p className="mt-2 text-muted-foreground leading-relaxed line-clamp-2">{p.excerpt}</p>
                </Link>
              </Reveal>
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
